import { render, staticRenderFns } from "./create-article.vue?vue&type=template&id=0fef239e&"
import script from "./create-article.vue?vue&type=script&lang=ts&"
export * from "./create-article.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-article.vue"
export default component.exports